import  ClientProcedureTableContainer from './ClientProcedureTableContainer';

export default  ClientProcedureTableContainer;